import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const fetchReviewRewards = () =>
  axios.get(`${API_URL}/api/loyalty/config`, { withCredentials: true }).then(({ data }) => toRewards(data));

export function toRewards(cfg) {
  const launch = !!cfg?.review_launch_bonus_active;
  return {
    launch,
    pts: Number(launch ? cfg?.review_launch_bonus_pts : cfg?.review_approval_pts) || 0,
    likePts: Number(cfg?.review_like_pts_per_like) || 0,
    photoLimit: Number(cfg?.review_photo_limit ?? 1),
  };
}

// "Earn {launch pts} bonus points for every review during launch" / "Earn {approval pts} points for every approved review"
export const reviewRewardHeadline = (r) => (r.launch
  ? `Earn ${r.pts} bonus points for every review during launch`
  : `Earn ${r.pts} points for every approved review`);

export function useReviewRewards(enabled = true) {
  const { data } = useQuery({ queryKey: ['loyalty', 'review-rewards'], queryFn: fetchReviewRewards, enabled, staleTime: 0 });
  return data || null;
}
